import { FunctionComponent } from "react"
import { Alert, Button, Col, Row, Table } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate } from "react-router-dom"
import FilterField from "../components/FilterField"
import { Entity } from "../data/models.interface"
import { useGetEntitiesQuery } from "../hooks/queries/useGetEntitiesQuery"
import useSessionStorage from "../hooks/useSessionStorage"
import useSort from "../hooks/useSort"
import { filterProperty } from "../utils/StringUtils"

interface IEntitiesPage {}
const EntitiesPage: FunctionComponent<IEntitiesPage> = () => {
	const navigate = useNavigate()
	const entitiesQuery = useGetEntitiesQuery()
	const entities = entitiesQuery.data?.entities
	// loading layout
	const loading = !entities
	const error = entitiesQuery.error
	if (loading) return <LoadingLayout error={error} />
	// normal layout
	return (
		<Container fluid>
			<h2 className="text-center mt-4">Employees & Vendors</h2>
			<EntitiesTable entities={entities} />
			<Row>
				<Col xs="auto">
					<BackButton />
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="success" onClick={() => navigate("/entities/new")}>
						New
					</Button>
				</Col>
			</Row>
		</Container>
	)
}
export default EntitiesPage

interface ILoadingLayout {
	error?: string
}
const LoadingLayout: FunctionComponent<ILoadingLayout> = ({ error }) => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Employees & Vendors</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">Loading</div>
		</Container>
	)
}

interface IEntitiesTable {
	entities: Entity[]
}
const EntitiesTable: FunctionComponent<IEntitiesTable> = ({ entities }) => {
	const navigate = useNavigate()
	const [nameFilter, setNameFilter] = useSessionStorage("entities-name", "")
	const [typeFilter, setTypeFilter] = useSessionStorage("entities-type", "")
	const [keyFilter, setKeyFilter] = useSessionStorage("entities-keycard", "")
	const { sortBy, sort } = useSort<Entity>("name")
	entities = filterProperty(entities, (e) => e.name!, nameFilter)
	entities = filterProperty(entities, (e) => e.type, typeFilter)
	entities = filterProperty(entities, (e) => e.keycards.join(", "), keyFilter)
	entities = sort(entities)
	return (
		<Table striped bordered hover size="sm">
			<thead>
				<tr>
					<th onClick={() => sortBy("name")}>Name</th>
					<th onClick={() => sortBy("type")}>Type</th>
					<th>Keycards</th>
					<th>Roles</th>
					<th>Passes</th>
				</tr>
				<tr>
					<td>
						<FilterField filter={nameFilter} setFilter={setNameFilter} placeholder="Filter Name" />
					</td>
					<td>
						<FilterField filter={typeFilter} setFilter={setTypeFilter} placeholder="Filter Type" />
					</td>
					<td>
						<FilterField filter={keyFilter} setFilter={setKeyFilter} placeholder="Filter Keycards" />
					</td>
				</tr>
			</thead>
			<tbody>
				{entities?.map((entity) => (
					<tr key={entity.id} onClick={() => navigate(`/entities/${entity.id}`)}>
						<td>{entity.name}</td>
						<td>{entity.type}</td>
						<td>{joinKeycards(entity.keycards)}</td>
						<td>{entity.roleIds?.length}</td>
						<td>{entity.passes?.length}</td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}

const BackButton: FunctionComponent = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}

const joinKeycards = (keycards: string[]) => {
	if (keycards.length > 12) {
		return keycards.slice(0, 11).join(", ") + "..."
	}
	return keycards.join(", ")
}
